import { postTrackingLinksAccessLogs } from './postTrackingLinksAccessLogs';

export const trackingLinkService = {
  postTrackingLinksAccessLogs,
};
